import { Requests } from "../common/request.common";
import { UserDeviceBindingResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const userDeviceBinding = {
    record(data: typeof Requests.UserDeviceBinding.Record.Input) {
        return post<typeof data, UserDeviceBindingResponseTypes.Record>(
            "/user-device-binding/record",
            data,
        );
    },
    obtain(id: string) {
        return get<UserDeviceBindingResponseTypes.Obtain>(`/user-device-binding/obtain/${id}`);
    },
    modifyPending(id: string, data: typeof Requests.UserDeviceBinding.ModifyPending.Input) {
        return post<typeof data, UserDeviceBindingResponseTypes.Obtain>(
            `/user-device-binding/modify/${id}`,
            data,
        );
    },
    deleteAllDeviceBinding(userAttendanceId: string) {
        return postEmpty(`/user-device-binding/delete-all-by-user/${userAttendanceId}`);
    },
};
